import moment from "moment";

const WEEKDAYS = ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"];
const MONTHS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

// "Seg, 2 nov"
export const formatDayShort = (dateStr) => {
  const m = moment(dateStr, "YYYY-MM-DD");
  return `${cap(WEEKDAYS[m.day()])}, ${m.date()} ${MONTHS[m.month()]}`;
};

// "Hoje · ter, 27 out" / "Amanhã · qua, 28 out" / "Seg, 2 nov"
export const formatDayGroup = (dateStr) => {
  const m = moment(dateStr, "YYYY-MM-DD");
  const today = moment().startOf("day");
  const diff = m.diff(today, "days");
  const base = `${WEEKDAYS[m.day()]}, ${m.date()} ${MONTHS[m.month()]}`;
  if (diff === 0) return `Hoje · ${base}`;
  if (diff === 1) return `Amanhã · ${base}`;
  if (diff === -1) return `Ontem · ${base}`;
  return formatDayShort(dateStr);
};

export const formatDate = (dateStr) => moment(dateStr, "YYYY-MM-DD").format("DD/MM/YYYY");

// "2h", "1h30", "45min"
export const formatDuration = (startTime, endTime) => {
  const [sh, sm] = startTime.split(":").map(Number);
  const [eh, em] = endTime.split(":").map(Number);
  const total = eh * 60 + em - (sh * 60 + sm);
  if (total <= 0) return "";
  const h = Math.floor(total / 60);
  const mi = total % 60;
  if (h === 0) return `${mi}min`;
  return mi === 0 ? `${h}h` : `${h}h${String(mi).padStart(2, "0")}`;
};

export const initials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p.charAt(0).toUpperCase())
    .join("") || "?";

const AVATAR_COLORS = ["#00897B", "#6A1B9A", "#EF6C00", "#1565C0", "#AD1457", "#2E7D32", "#5D4037", "#4527A0"];
export const avatarColor = (id) => AVATAR_COLORS[Math.abs(Number(id) || 0) % AVATAR_COLORS.length];

// Junta bloqueios de dias seguidos (mesmo profissional, motivo e período)
// em um único item. Cada item: { key, ids, blocks, user, userId, dateStart,
// dateEnd, days, isFullDay, startTime, endTime, reason }.
export const groupBlocks = (blocks) => {
  const sig = (b) =>
    [b.userId, b.isFullDay ? 1 : 0, b.startTime || "", b.endTime || "", b.reason || ""].join("|");
  const sorted = [...blocks].sort((a, b) =>
    sig(a) === sig(b) ? a.date.localeCompare(b.date) : sig(a).localeCompare(sig(b))
  );

  const items = [];
  sorted.forEach((b) => {
    const last = items[items.length - 1];
    if (
      last &&
      sig(last.blocks[0]) === sig(b) &&
      moment(b.date, "YYYY-MM-DD").diff(moment(last.dateEnd, "YYYY-MM-DD"), "days") === 1
    ) {
      last.blocks.push(b);
      last.ids.push(b.id);
      last.dateEnd = b.date;
      last.days += 1;
      return;
    }
    items.push({
      key: `${b.id}`,
      ids: [b.id],
      blocks: [b],
      user: b.user,
      userId: b.userId,
      dateStart: b.date,
      dateEnd: b.date,
      days: 1,
      isFullDay: b.isFullDay,
      startTime: b.startTime,
      endTime: b.endTime,
      reason: b.reason,
    });
  });

  return items.sort(
    (a, b) =>
      a.dateStart.localeCompare(b.dateStart) ||
      (a.startTime || "").localeCompare(b.startTime || "") ||
      (a.user?.name || "").localeCompare(b.user?.name || "")
  );
};

export const periodLabel = (item) =>
  item.isFullDay ? "Dia inteiro" : `${item.startTime} – ${item.endTime}`;
